import React from 'react'
import PropTypes from 'prop-types'
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'
import { linkFacebook } from '../../../api/facebook'
import Base from './base'

const DEFAULT_APP_ID = '106401512762894'

const callbackWrapper =
  (onFacebookConnectedChange, onError, onConnectStart, onConnectFinish) => facebookResponse => {
    if (facebookResponse.status === 'unknown') return

    if (onConnectStart) onConnectStart()
    linkFacebook(facebookResponse.id)
      .then(r => onFacebookConnectedChange(r, facebookResponse.id, facebookResponse.name))
      .catch(err => onError(err))
      .finally(() => {
        if (onConnectFinish) onConnectFinish()
      })
  }

const Component = props => {
  const {
    facebookAppId,
    checked,
    onFacebookConnectedChange,
    onError,
    onConnectStart,
    onConnectFinish,
    onClick,
  } = props
  return (
    <FacebookLogin
      appId={facebookAppId || DEFAULT_APP_ID}
      autoLoad={false}
      disableMobileRedirect
      callback={callbackWrapper(
        onFacebookConnectedChange,
        onError,
        onConnectStart,
        onConnectFinish
      )}
      render={renderProps => (
        <Base
          checked={checked}
          connectToFacebook={renderProps.onClick}
          onFacebookConnectedChange={onFacebookConnectedChange}
          onClick={onClick}
        />
      )}
    />
  )
}

Component.propTypes = {
  facebookAppId: PropTypes.string,
  onFacebookConnectedChange: PropTypes.func.isRequired,
  onError: PropTypes.func,
  onConnectStart: PropTypes.func,
  onConnectFinish: PropTypes.func,
  onClick: PropTypes.func,
  checked: PropTypes.bool,
}

export default Component
